import {penceFromPounds} from "../../../../utils/currency";

import {type AdvancedRentPricing, calculatePayout, toPlans} from "./payout";

function fmtPounds(pennies: number): string {
  return "£" + Math.round(pennies / 100).toLocaleString("en-GB");
}

function fmtPoundsDec(pennies: number): string {
  return "£" + (pennies / 100).toLocaleString("en-GB", {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export const updateRentUpfrontCalculator = (el: Element) => {
  const data = el.getAttribute("data-landlords-landing");
  if (!data) {
    console.error("No data found for landlords landing page", el);
    return;
  }

  const plans = toPlans(JSON.parse(data) as AdvancedRentPricing);

  const rentInput = document.getElementById("rentInput") as HTMLInputElement | null;
  const calcLabel = document.getElementById("calcLabel");

  if (!rentInput) {
    return;
  }

  const setText = (id: string, text: string) => {
    const node = document.getElementById(id);
    if (node) {
      node.textContent = text;
    }
  };

  const setHidden = (id: string, hidden: boolean) => {
    const node = document.getElementById(id);
    if (node) {
      node.classList.toggle("hidden", hidden);
    }
  };

  const render = () => {
    // oxlint-disable-next-line typescript-eslint/no-non-null-assertion
    const raw = rentInput!.value.replace(/[^0-9.]/g, "");
    const parsedPounds = Number.parseFloat(raw);
    const hasValue = !Number.isNaN(parsedPounds) && parsedPounds > 0;
    const monthlyRentPennies = hasValue ? penceFromPounds(parsedPounds) : 0;

    if (calcLabel) {
      calcLabel.textContent = hasValue
        ? `Based on ${fmtPounds(monthlyRentPennies)} pm monthly rent`
        : "Estimated payouts";
    }

    for (const plan of plans) {
      const p = plan.months;
      setHidden(`calc-empty-${p}`, hasValue);
      setHidden(`calc-filled-${p}`, !hasValue);

      if (hasValue) {
        const {gross, rateFee, payout} = calculatePayout(monthlyRentPennies, plan);
        setText(`calc-payout-${p}`, fmtPounds(payout));
        setText(`calc-gross-${p}`, fmtPounds(gross));
        setText(`calc-ratefee-${p}`, `−${fmtPoundsDec(rateFee)}`);
        setText(`calc-net-${p}`, fmtPounds(payout));
      }
    }
  };

  render();

  // oxlint-disable-next-line typescript-eslint/no-non-null-assertion
  rentInput!.addEventListener("input", function () {
    const raw = this.value.replace(/[^0-9.]/g, "");
    const cursorPos = this.selectionStart ?? this.value.length;
    const prevLen = this.value.length;

    if (raw !== "" && !raw.endsWith(".")) {
      // oxlint-disable-next-line typescript-eslint/no-non-null-assertion
      const intPart = raw.split(".")[0]!;
      const decPart = raw.includes(".") ? "." + raw.split(".")[1] : "";
      const formatted = Number.parseInt(intPart, 10).toLocaleString("en-GB") + decPart;
      this.value = formatted;
      const newLen = this.value.length;
      this.setSelectionRange(cursorPos + (newLen - prevLen), cursorPos + (newLen - prevLen));
    }

    render();
  });
};

const el = document.currentScript;
if (el) {
  updateRentUpfrontCalculator(el);
}
